import { ReactNode } from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { isAuthConfigured } from '../../config/authConfig';
import { LoginPage } from './LoginPage';
import { Spinner } from '../UI';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  // Si la autenticación no está configurada, permitir acceso sin login
  if (!isAuthConfigured()) {
    return <>{children}</>;
  }

  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();

  // Mostrar spinner mientras se procesa la autenticación
  if (inProgress !== InteractionStatus.None) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <Spinner size="lg" className="mx-auto mb-4" />
          <p className="text-gray-600">Verificando autenticación...</p>
        </div>
      </div>
    );
  }

  // Si no está autenticado, mostrar página de login
  if (!isAuthenticated) {
    return <LoginPage />;
  }

  // Usuario autenticado, mostrar contenido protegido
  return <>{children}</>;
}
